/* ============================================================
   BoardView — select 속성 기준 칸반 보드 뷰
   - 2026-07-06 DatabasePage.jsx 에서 그대로 추출(동작 동일) —
     DatabaseEmbed(링크된 DB 인라인 뷰)와 공유하기 위한 분리.
   - v1: 드래그 없이 카드 내 드롭다운으로 그룹 이동 (updateCell)
   ============================================================ */
import { useMemo } from 'react';
import { optClass, avaColor, fmtShort } from './viewPipeline';
import { personNames } from './computeValue';

function firstSelectKey(columns) {
  const c = columns.find((x) => x.type === 'select');
  return c?.key;
}

export default function BoardView({ columns, rows, view, peopleById, updateCell, createRow, onChangeGroupBy }) {
  const selectCols = columns.filter((c) => c.type === 'select');
  const groupKey = view.config?.groupBy || firstSelectKey(columns);
  const groupCol = columns.find((c) => c.key === groupKey);
  const dateCol = columns.find((c) => c.type === 'date');
  const personCol = columns.find((c) => c.type === 'person');

  // 그룹: 옵션 + (옵션 없는) 미지정
  const options = groupCol?.options || [];
  const groups = useMemo(() => {
    const map = {};
    options.forEach((o) => { map[o.name] = []; });
    map.__none = [];
    rows.forEach((r) => {
      const v = r.properties?.[groupKey];
      if (v && map[v]) map[v].push(r);
      else map.__none.push(r);
    });
    return map;
  }, [rows, options, groupKey]);

  const cols = [...options.map((o) => o.name)];
  if (groups.__none && groups.__none.length) cols.push('__none');

  return (
    <div>
      <div className="grp-bar">
        <span className="grp-label">그룹 기준</span>
        {selectCols.length ? (
          <select
            className="grp-select"
            value={groupKey || ''}
            onChange={(e) => onChangeGroupBy(e.target.value)}
          >
            {selectCols.map((c) => (
              <option key={c.key} value={c.key}>{c.name}</option>
            ))}
          </select>
        ) : (
          <span className="grp-hint">선택(select) 타입 컬럼이 없습니다. 표 뷰에서 추가하세요.</span>
        )}
      </div>
      {!groupCol ? (
        <div className="db-state">
          <div className="big">🗂️</div>
          <div>그룹으로 사용할 선택(select) 컬럼을 만들어 주세요.</div>
        </div>
      ) : (
        <div className="board">
          {cols.map((name) => {
            const list = groups[name] || [];
            const isNone = name === '__none';
            const cls = isNone ? 'tg' : optClass(groupCol, name);
            return (
              <div className="bcol" key={name}>
                <div className="bch">
                  <span className={`tag ${cls}`}>{isNone ? '미지정' : name}</span>
                  <span className="cnt">{list.length}</span>
                </div>
                {list.map((r) => {
                  // person 값: user id 배열(신규) / 평문 문자열(레거시) 모두 이름으로 해석
                  const pNames = personCol ? personNames(r.properties?.[personCol.key], peopleById) : [];
                  return (
                  <div className="bcard" key={r.page_id}>
                    <div className="bt">{r.icon || '📄'} {r.title || '제목 없음'}</div>
                    <div className="bm">
                      {pNames.length > 0 && (
                        <span className="mav" style={{ background: avaColor(pNames[0]) }} title={pNames.join(', ')}>
                          {pNames[0][0]}
                        </span>
                      )}
                      {dateCol && r.properties?.[dateCol.key] && (
                        <span>{fmtShort(r.properties[dateCol.key])}</span>
                      )}
                      {/* v1: 드래그 없이 드롭다운으로 그룹 이동 */}
                      <span className="move">
                        <select
                          value={isNone ? '' : name}
                          onChange={(e) => updateCell(r.page_id, groupKey, e.target.value)}
                        >
                          <option value="">미지정</option>
                          {options.map((o) => (
                            <option key={o.name} value={o.name}>{o.name}</option>
                          ))}
                        </select>
                      </span>
                    </div>
                  </div>
                  );
                })}
                {!isNone && (
                  <button className="bnew" onClick={() => createRow({ [groupKey]: name })}>＋ 새로 만들기</button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
